import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from '@material-ui/core'
import { useStyles } from './spp-wl-filter.styles'
import { useState } from 'react'
import AsterTypography from 'asterX-UI/Typography/AsterTypography'
import { AutoCompleteField } from 'asterX-UI/Inputs'
import AsterButton from 'asterX-UI/Buttons/AsterButton'
import { ArrowForwardIosRounded } from '@material-ui/icons'
import { KeyboardDatePicker } from '@material-ui/pickers'
import DateIcon from 'asterX-UI/Icons/DateIcon'
import MaskedTextInput from 'asterX-UI/Inputs/MackedTextInput'
import { creationTypes, dateTypes, paymentTypes, saleTypes } from './const'
import { AllStatusesDeal } from 'constants/deals'
import { useHomeStoreSpp } from 'context/HomeStore/SPP'

export const SppWLFilter = () => {
  const classes = useStyles()

  const {
    homeStore: {
      branches,
      models,
      marks,
      managers,
      subdivisions,
      selectedBranch,
      selectedMng,
      selectedSubdivision,
      wlFilter,
      wlTab
    },
    homeStoreFunc: {
      handleFilterChange,
      handleDateChange,
      handleClearFilter,
      getWlList,
      setSelectedMng,
      setSelectedBranch,
      setSelectedSubdivision
    }
  } = useHomeStoreSpp()

  const [expanded, setExpanded] = useState(false)

  return (
    <Grid item xs={12}>
      <Accordion expanded={expanded} className={classes.accordion}>
        <AccordionSummary className={classes.accordionSummary}>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <AsterTypography variant="h6">Фильтр</AsterTypography>
            </Grid>
            <Grid item container spacing={3}>
              <Grid item xs={6} md={4} lg={3}>
                <TextField
                  name="id"
                  value={wlFilter.id}
                  onChange={handleFilterChange}
                  fullWidth
                  label="Номер рабочего листа"
                />
              </Grid>
              <Grid item xs={6} md={4} lg={3}>
                <TextField
                  name="eventId"
                  value={wlFilter.eventId}
                  onChange={handleFilterChange}
                  fullWidth
                  label="Номер задачи"
                />
              </Grid>
              {wlTab !== 0 && (
                <Grid item xs={6} md={4} lg={3}>
                  <AutoCompleteField
                    name="statusCodes"
                    value={wlFilter.statusCodes}
                    multiple
                    onChange={handleFilterChange}
                    fullWidth
                    label="Статус"
                    keyArr="code"
                    valueKey={'code'}
                    options={AllStatusesDeal}
                  />
                </Grid>
              )}
              <Grid item xs={6} md={4} lg={3}>
                <AutoCompleteField
                  value={selectedMng}
                  onChange={({ target: { value } }) => setSelectedMng(value)}
                  fullWidth
                  label="Менеджер"
                  labelKey="fullName"
                  name="managers"
                  valueKey={'username'}
                  options={managers}
                />
              </Grid>
              <Grid item xs={6} md={4} lg={3}>
                <AutoCompleteField
                  value={selectedBranch || ''}
                  onChange={({ target: { value } }) => setSelectedBranch(value)}
                  fullWidth
                  label="Филиал"
                  name="branchCode"
                  valueKey={'code'}
                  options={branches}
                />
              </Grid>
              <Grid item xs={6} md={4} lg={3}>
                <AutoCompleteField
                  value={selectedSubdivision || ''}
                  fullWidth
                  label="Звено"
                  name="subdivision"
                  labelKey="rop"
                  onChange={({ target: { value } }) =>
                    setSelectedSubdivision(value)
                  }
                  options={subdivisions}
                />
              </Grid>
              <Grid item xs={6} md={4} lg={3}>
                <TextField
                  name="vin"
                  value={wlFilter.vin || null}
                  onChange={handleFilterChange}
                  fullWidth
                  label="VIN-код"
                />
              </Grid>
            </Grid>

            <Grid
              item
              container
              alignItems="center"
              justifyContent="space-between"
              className={classes.fixedBtns}
            >
              <Grid item>
                <AsterButton
                  className={classes.expandBtn}
                  onClick={() => setExpanded(!expanded)}
                >
                  {expanded ? 'Свернуть' : 'Расширенный поиск'}
                  <ArrowForwardIosRounded
                    className={classes.expandBtnIcon}
                    style={{ transform: `rotate(${expanded ? -90 : 90}deg)` }}
                  />
                </AsterButton>
              </Grid>
              <Grid item style={{ marginLeft: 'auto', marginRight: 10 }}>
                <AsterButton onClick={handleClearFilter}>Сбросить</AsterButton>
              </Grid>
              <Grid item>
                <AsterButton color="primary" onClick={getWlList}>
                  Показать результаты
                </AsterButton>
              </Grid>
            </Grid>
          </Grid>
        </AccordionSummary>

        <AccordionDetails className={classes.accordionDetails}>
          <Grid container spacing={4}>
            <Grid item container alignItems="center" spacing={3}>
              <Grid item>
                <AsterTypography variant="h6">Рабочий лист</AsterTypography>
              </Grid>
              <Grid item style={{ flexGrow: 1 }}>
                <Divider />
              </Grid>
            </Grid>
            <Grid item container spacing={3}>
              <Grid item xs={6} md={4} lg={3}>
                <FormControl fullWidth>
                  <InputLabel>Тип даты</InputLabel>
                  <Select
                    name="dateType"
                    value={wlFilter.dateType}
                    onChange={handleFilterChange}
                  >
                    {dateTypes.map(({ name, label }) => (
                      <MenuItem key={name} value={name}>
                        {label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} md={4} lg={3}>
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="dd.MM.yyyy"
                  label="Дата начала"
                  name="dateFrom"
                  value={wlFilter.dateFrom}
                  onChange={val => handleDateChange(val, 'dateFrom')}
                  keyboardIcon={<DateIcon />}
                />
              </Grid>
              <Grid item xs={6} md={4} lg={3}>
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="dd.MM.yyyy"
                  label="Дата конца"
                  name="dateTo"
                  value={wlFilter.dateTo}
                  onChange={val => handleDateChange(val, 'dateTo')}
                  keyboardIcon={<DateIcon />}
                />
              </Grid>
              <Grid item xs={6} md={4} lg={3}>
                <FormControl fullWidth>
                  <InputLabel>Формат оплаты</InputLabel>
                  <Select
                    name="saleType"
                    value={wlFilter.saleType}
                    onChange={handleFilterChange}
                  >
                    {saleTypes.map(e => (
                      <MenuItem key={e} value={e} name={e}>
                        {e}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} md={4} lg={3}>
                <FormControl fullWidth>
                  <InputLabel>Тип оплаты</InputLabel>
                  <Select
                    name="paymentType"
                    value={wlFilter.paymentType}
                    onChange={handleFilterChange}
                  >
                    {paymentTypes.map(e => (
                      <MenuItem key={e} value={e} name={e}>
                        {e}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} md={4} lg={3}>
                <FormControl fullWidth>
                  <InputLabel>Тип создания</InputLabel>
                  <Select
                    name="creationType"
                    value={wlFilter.creationType}
                    onChange={handleFilterChange}
                  >
                    {creationTypes.map(e => (
                      <MenuItem key={e} value={e.value} name={e.name}>
                        {e.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item container>
                <Grid item>
                  <FormControlLabel
                    control={
                      <Checkbox
                        value={wlFilter.carst}
                        color="primary"
                        name="carst"
                        onChange={e => handleFilterChange(e)}
                      />
                    }
                    label="Подвод"
                  />
                </Grid>
                <Grid item>
                  <FormControlLabel
                    control={
                      <Checkbox
                        value={wlFilter.trade}
                        color="primary"
                        name="trade"
                        onChange={e => handleFilterChange(e)}
                      />
                    }
                    label="Trade In"
                  />
                </Grid>
                <Grid item>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={wlFilter.ropCheck}
                        color="primary"
                        onChange={e => handleFilterChange(e)}
                        name="ropCheck"
                      />
                    }
                    label="Проверено РОП"
                  />
                </Grid>
                <Grid item>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={wlFilter.ropCheckFalse}
                        color="primary"
                        onChange={e => handleFilterChange(e)}
                        name="ropCheckFalse"
                      />
                    }
                    label="Не Проверено РОП"
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item container alignItems="center" spacing={3}>
              <Grid item>
                <AsterTypography variant="h6">Авто</AsterTypography>
              </Grid>
              <Grid item style={{ flexGrow: 1 }}>
                <Divider />
              </Grid>
            </Grid>
            <Grid item xs={6} md={4} lg={3}>
              <AutoCompleteField
                name="marka"
                value={wlFilter.marka || null}
                onChange={handleFilterChange}
                fullWidth
                options={marks}
                label="Марка"
              />
            </Grid>
            <Grid item xs={6} md={4} lg={3}>
              <AutoCompleteField
                name="model"
                value={wlFilter.model || null}
                onChange={handleFilterChange}
                fullWidth
                label="Модель"
                options={models}
              />
            </Grid>
            <Grid item container alignItems="center" spacing={3}>
              <Grid item>
                <AsterTypography variant="h6">Клиент</AsterTypography>
              </Grid>
              <Grid item style={{ flexGrow: 1 }}>
                <Divider />
              </Grid>
            </Grid>
            <Grid item xs={6} md={4} lg={3}>
              <MaskedTextInput
                name="phoneNumber"
                value={wlFilter.phoneNumber}
                onChange={handleFilterChange}
                mask="+7 (999) 999-99-99"
                fullWidth
                label="Номер телефона"
              />
            </Grid>
            <Grid item xs={6} md={4} lg={3}>
              <TextField
                name="firstName"
                value={wlFilter.firstName}
                onChange={handleFilterChange}
                fullWidth
                label="Имя"
              />
            </Grid>
            <Grid item xs={6} md={4} lg={3}>
              <TextField
                name="lastName"
                value={wlFilter.lastName}
                onChange={handleFilterChange}
                fullWidth
                label="Фамилия"
              />
            </Grid>
            <Grid item xs={6} md={4} lg={3}>
              <MaskedTextInput
                name="iin"
                value={wlFilter.iin}
                onChange={handleFilterChange}
                mask="999999999999"
                fullWidth
                label="ИИН"
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Grid>
  )
}
